import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLaunchBoardroom } from "@/lib/onboarding";

export default function FinalCta() {
  const launch = useLaunchBoardroom();
  return (
    <section
      data-testid="final-cta"
      className="relative overflow-hidden px-5 py-32 md:px-8 md:py-40"
    >
      {/* Radial gradient bg */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 -z-10"
        style={{
          background:
            "radial-gradient(ellipse 80% 60% at 50% 50%, rgba(124,58,237,0.18) 0%, rgba(34,211,238,0.12) 38%, rgba(247,247,245,0) 70%)",
        }}
      />

      <div className="mx-auto max-w-5xl text-center">
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.6 }}
          className="text-[60px] font-black leading-[0.95] tracking-[-0.04em] text-zinc-900 md:text-[120px]"
          style={{ fontWeight: 900 }}
        >
          Stop building<br />
          <span className="bg-gradient-to-r from-violet-700 via-fuchsia-600 to-cyan-500 bg-clip-text text-transparent">
            alone.
          </span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="mx-auto mt-6 max-w-xl text-[16px] leading-relaxed text-zinc-600 md:text-[19px]"
        >
          Step into your boardroom. Ship like a fully staffed team.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="mt-10 flex flex-col items-center gap-3"
        >
          <button
            type="button"
            onClick={launch}
            data-testid="final-cta-button"
            className="group inline-flex h-14 items-center gap-2 rounded-full bg-black px-7 text-[15px] font-semibold text-white transition-all hover:-translate-y-0.5 hover:bg-zinc-800 hover:shadow-[0_24px_48px_-20px_rgba(0,0,0,0.6)]"
          >
            Launch boardroom
            <ArrowRight
              className="h-4 w-4 transition-transform group-hover:translate-x-0.5"
              strokeWidth={2.4}
            />
          </button>
        </motion.div>
      </div>
    </section>
  );
}
